module.exports = __webpack_public_path__ + "img/1F929.f71d89a0.svg";